export default __webpack_public_path__ + "static/media/3284.8212061c.png";